// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1p-0";
export var spinnerContainer = "_1p-1";